import playStore from './ediliziapp-googlestore.png';
import headerLogo from './ediliziapp-ff.png';

const Images = {
    playStore,
    headerLogo,
}

export default Images;
